import * as React from "react";
import { today, startDate, endDate } from "src/util/blackDecember";
import styled from "styled-components";

export default function ProgressDaysRemaining() {
  const timeDifference = Math.abs(startDate.getTime() - endDate.getTime());
  const timeDifferenceToday = Math.abs(startDate.getTime() - today.getTime());
  const differentDays = Math.ceil(timeDifference / (1000 * 3600 * 24));
  const differenceDaysToday = Math.ceil(timeDifferenceToday / (1000 * 3600 * 24));
  const width = (100 * differenceDaysToday) / differentDays;
  const Style = styled.span`
    &:before {
      width: ${width}%;
    }
  `;
  return (
    <div className="progress-days-remaining">
      <Style className="progress-bar" data-time={differenceDaysToday} data-difference={differentDays} data-width={width}>
        <span>Início</span>
        <span>Fim</span>
      </Style>
      <strong>{differenceDaysToday} dias</strong> restantes de promoção
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/welcome/black-december/ProgressDaysRemaining.tsx